var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Head'),_vm._v(" "),_c('div',{staticClass:"index"},[_c('Leftside',{staticStyle:{"flex":"1"},attrs:{"isActive":_vm.isActive},on:{"leftnav":_vm.nav}}),_vm._v(" "),_c('div',{staticClass:"content",staticStyle:{"flex":"5"}},[_c('mainnav',{attrs:{"navActive":_vm.navActive}}),_vm._v(" "),_c('Court')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15794fb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/court.vue
// module id = null
// module chunks = 